import { useContext } from 'react';

import { GpuUtilizationContext } from '../providers/GpuUtilizationProvider';

export const useGpuUtilization = () => {
  return useContext(GpuUtilizationContext);
};
